$mol_form_field $mol_labeler
	bids /string
	label /
		<= name \
		<= Bid $mol_view
			sub / <= bid \
	content / <= control null
